import React from 'react';
import { Calendar, Trash2 } from 'lucide-react';

const DueDateSelector = ({
  dueAt,
  onChange,
  onClear,
  isRequired = false,
  minDate = new Date(),
  className = ""
}) => {
  const formatDate = (date) => {
    if (!date) return '';
    return date instanceof Date
      ? date.toISOString().split('T')[0]
      : new Date(date).toISOString().split('T')[0];
  };

  const formatTime = (date) => {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  };

  const handleDateChange = (e) => {
    const newDate = e.target.value ? new Date(e.target.value + 'T00:00:00') : null;
    if (newDate) {
        // Keep existing time or set to current time if no previous date
        const prevDate = dueAt ? new Date(dueAt) : new Date();
        newDate.setHours(prevDate.getHours());
        newDate.setMinutes(prevDate.getMinutes());
    }
    onChange(newDate?.toISOString() || null);
};

  const handleTimeChange = (e) => {
    if (!dueAt) return;
    const [hours, minutes] = e.target.value.split(':');
    const newDate = new Date(dueAt);
    newDate.setHours(parseInt(hours), parseInt(minutes));
    onChange(newDate.toISOString());
  };

  const minDateString = minDate ? formatDate(minDate) : '';

  return (
    <div className={`${className} space-y-2`}>
      <div className="grid grid-cols-3 gap-2">
        <input
          type="date"
          value={formatDate(dueAt)}
          onChange={handleDateChange}
          min={minDateString}
          required={isRequired}
          className={`col-span-2 px-2 py-1 border rounded
            focus:ring-2 focus:ring-purple-500 focus:border-transparent
            ${isRequired && !dueAt ? 'border-red-300' : 'border-gray-300'}`}
        />
        <input
          type="time"
          value={formatTime(dueAt)}
          onChange={handleTimeChange}
          className="px-2 py-1 border rounded focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          disabled={!dueAt}
        />
      </div>

      <div className="flex justify-between items-center text-sm">
        <span className="text-gray-600">
          {dueAt
            ? new Date(dueAt).toLocaleString()
            : isRequired
              ? 'Required'
              : 'Optional'
          }
        </span>
        {dueAt && (
          <button
            onClick={() => onClear()}
            className="text-red-600 hover:text-red-800 transition-colors p-1"
            title="Clear date"
          >
            <Trash2 size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default DueDateSelector;